import { render, staticRenderFns } from "./RoomForm.vue?vue&type=template&id=ee226fb2&scoped=true&"
import script from "./RoomForm.vue?vue&type=script&lang=js&"
export * from "./RoomForm.vue?vue&type=script&lang=js&"
import style0 from "./RoomForm.vue?vue&type=style&index=0&id=ee226fb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee226fb2",
  null
  
)

component.options.__file = "RoomForm.vue"
export default component.exports